var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-builder-component',{attrs:{"node":_vm.contentTree}})}
var staticRenderFns = []

export { render, staticRenderFns }